/**
 *
 * Merchant Location List
 *
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MerchantLocationCard from './MerchantLocationCard';
import EmptyList from './EmptyList';
import ShowMoreButton from './ShowMoreButton';

export const INITIAL_NUM_LOCATIONS = 5;
const SPACING = '24px';

const CardContainer = styled.div`
  padding: ${SPACING} 0;
  border-top: 1px solid ${({ theme }) => theme.palette.grey[300]};
  :last-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
  }
`;

const MerchantLocationList = ({
  searchQuery = null,
  merchants = [],
  initialCount = INITIAL_NUM_LOCATIONS,
  className = null,
}) => {
  const [showMore, setShowMore] = useState(
    merchants && merchants.length <= initialCount,
  );

  if (!merchants || !merchants.length) {
    const noSearchQuery = searchQuery == null || searchQuery.length === 0;
    return (
      <EmptyList noSearchQuery={noSearchQuery} searchQuery={searchQuery} />
    );
  }

  const merchantsData = showMore ? merchants : merchants.slice(0, initialCount);
  return (
    <div className={className}>
      <div>
        {merchantsData.map(({ id, ...merchantData }) => (
          <CardContainer key={id} data-testid="merchant-location-list-card">
            <MerchantLocationCard {...merchantData} />
          </CardContainer>
        ))}
      </div>
      {!showMore && <ShowMoreButton onClick={() => setShowMore(true)} />}
    </div>
  );
};

MerchantLocationList.propTypes = {
  searchQuery: PropTypes.string,
  merchants: PropTypes.arrayOf(PropTypes.shape()),
  initialCount: PropTypes.number,
  className: PropTypes.string,
};

export default MerchantLocationList;
